<script>
import BaseShareButton from '@/components/common/BaseShareButton';

export default {
    extends: BaseShareButton
};
</script>
